export default __webpack_public_path__ + "static/media/11. Pravila vzyatia i hranenia biologicheskogo materiala.6ce0a452.pdf";